import axios from 'axios';
import Qs from 'qs';
import { API_URL } from '../common';
import { deleteCookie, getEventCards, setCookie } from '../helpers';
import { createImprintHash } from '../logger/imprintHash.js';

export const axiosClient = axios.create({
  withCredentials: true,
});

axiosClient.interceptors.request.use(async (config) => {
  try {
    const imprint = await createImprintHash();
    const appId = localStorage.getItem('appId');
    const appVersion = localStorage.getItem('appVersion');

    localStorage.setItem('imprint', imprint);
    window.dispatchEvent(new CustomEvent('imprintReady', { detail: imprint }));
    config.headers['Imprinthash'] = imprint;

    if (appId) {
      config.headers['app-id'] = appId;
    }

    if (appVersion) {
      config.headers.version = appVersion;
    }
  } catch (e) {
    console.error('Failed to create imprintHash', e);
  }

  return config;
});

/**
 * Получить правила фрибета по promo_id
 * @param {Number} promo_id Id правил фрибета на сервера
 * @param {Number} [id=0] Элемент массива с правилами фрибета
 * @returns {Promise<AxiosResponse<any>>}
 */
//TODO есть дубликат в реге
export const getRules = (promo_id, lang_id, id = 0, key) => {
  const data = new FormData();
  data.set(`id[${id}]`, 'freebet_rules');
  key && data.set(`id[${id}]`, key);
  data.set('data[promo_id]', promo_id);
  data.set('qwerty', 1);

  deleteCookie('lang');
  setCookie('lang', lang_id);
  return axiosClient.post(`${API_URL}/ajax/html/get`, data);
};

export const getQuest = (questId) =>
  axiosClient.get(`${API_URL}/ajax/quest/getById?questId=${questId}`);

/**
 * Получить общие данные пользователя
 * @returns {Promise<AxiosResponse<any>>}
 */
//TODO есть дубликат в реге
export const getAccountData = () => axiosClient.get(`${API_URL}/ajax/account/data`);

/**
 * Получить данные для регистрации (страны, языки, телефоны)
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getLocaleData = () =>
  axiosClient.get(`${API_URL}/ajax/locale/data?type=all&need_lang=1`);

/**
 * Получить currency data
 * @param {Number} country_id id страны, для которой нужна валюта
 * @returns {Promise<AxiosResponse<*>>}
 */

export const getCurrencyData = (country_id) =>
  getLocaleData()
    .then((response) =>
      Object.values(response.data.result.currency_data).find(
        (currency) => currency.number === Number(country_id),
      ),
    )
    .catch(null);

/**
 * Получить ссылку на демоигру слотегратора.
 * @param {string, number, string} uid uid игры, для которой нужна ссылка
 * @returns {Promise<AxiosResponse<*>>}
 */

export const initDemo = (uid, is_live, home_url) =>
  axiosClient.post(
    `${window.location.origin}/ajax/casino/init_demo`,
    Qs.stringify({ uid, is_live, home_url }),
  );

/**
 * Получить ссылку на игру слотегратора.
 * @param {string, number, string} uid uid игры, для которой нужна ссылка
 * @returns {Promise<AxiosResponse<*>>}
 */

export const initGame = (uid, is_live, home_url = '') =>
  axiosClient.post(
    `${window.location.origin}/ajax/casino/init_game`,
    Qs.stringify({ uid, is_live, home_url }),
  );
/**
 * Получить country data (lang_id, country_id)
 * @returns {Promise<AxiosResponse<*>>}
 */
export const getCountryData = () =>
  getLocaleData()
    .then((response) => response.data.result.country_data)
    .catch(null);

/**
 * Проверить, авторизирован ли пользователь
 * @returns {Promise<boolean>} true - авторизирован, false - НЕ авторизирован
 */
export const isAuthorizedUser = () =>
  getAccountData()
    .then((response) => !!response.data.result.access)
    .catch(() => false);

/**
 * Отправка логов в кафку
 * @param {Object} data Параметры для логирования
 */
export const logging = (data) => {
  const options = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  };
  axiosClient.post(`/api/metrics/v1/log`, data, options);
};

/**
 * Получить популярные события (с построением ЧПУ url)
 * @param {Boolean} isLangCyrillic Относится ли язык ленда к ru / kz / ua локали для определения языка (ru/eng) отображения информации на карточках
 * @param {Boolean} isAuth Авторизирован ли пользователь
 * @param {Number} countGames Количество выводимых событий
 */
export const getPopularEvents = (countryDataLangId, lang, isAuth, countGames = 6) => {
  const langId = countryDataLangId;
  const url = `${API_URL}/ajax/line/printer/ranked/1602834533?onlyview=0&lang_id=${langId}&timezone=3`;
  return axiosClient
    .get(url)
    .then((response) => getEventCards(lang, isAuth, countGames, response.data))
    .catch((err) => console.log(`Ошибка при запросе популярных событий: ${err}`));
};

/**
 * Получить параметры партнёрского оффера по промокоду
 * @param {String} promoCode Промокод из url
 */
export const getPartnerLanding = (promoCode) =>
  axiosClient.get(`${API_URL}/nws/v1/partner-landing/${encodeURIComponent(promoCode)}`);

export const getChannels = () =>
  axiosClient
    .get(`${API_URL}/ajax/company/support/get_channel`)
    .then((response) => response.data.result)
    .catch((err) => console.log(`Ошибка при запросе company channel: ${err}`));
